import { Controller } from "@hotwired/stimulus"

// Opens WhatsApp (Web on desktop, app on mobile) with prefilled text.
// Uses synthetic <a> click so popup blockers don't fire.
//
// Both single and bulk send pass text via action params (data-…-text-param)
// — these read from the clicked element, not the controller root,
// which is what we need for child buttons.
//
// We never auto-mark items as sent — the browser cannot know whether
// the user actually clicked Send inside WhatsApp.
export default class extends Controller {
  share(event) {
    const text = event.params.text
    if (!text) return
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`
    const a = document.createElement("a")
    a.href = url
    a.target = "_blank"
    a.rel = "noopener noreferrer"
    a.style.display = "none"
    document.body.appendChild(a)
    a.click()
    a.remove()
  }
}
